module.exports = __webpack_public_path__ + "media/images/icons/secure-21bf42e817593b95cf65e21d23dfd38d.svg";